export const REDUX_ERROR_OCCURED = '@store/REDUX_ERROR_OCCURED';
export const RESET_ERROR = '@store/RESET_REDUX_ERROR';

export const resetError = () => ({
  type: RESET_ERROR,
});
